<template>
  <v-card class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4">
    <h3 class="c-blue-text c-title tw-text-base md:tw-text-xl tw-px-0 md:tw-px-10">
      <slot></slot>
      <hr class="tw-mt-4">
    </h3>
    <div class="tw-w-full tw-flex">
      <div class="tw-w-full tw-flex tw-justify-center tw-my-5 md:tw-my-8 tw-flex-wrap">
        <template>
          <div class="tw-w-full tw-flex tw-flex-col tw-gap-5 md:tw-flex-row tw-items-center tw-mx-10">
            <div class="tw-w-full tw-mx-2 tw-flex tw-items-center tw-justify-center tw-border-0 md:tw-border-r">
              <img src="/images/icons/car-g.png" class="tw-h-16 lg:tw-h-auto tw-mr-2 lg:tw-mr-4" alt="car icon">
              <h3 class="c-blue-text c-title tw-text-base md:tw-text-base tw-px-2 md:tw-px-8"><span >{{ this.pageTitle }}</span></h3>
            </div>
            <div v-if="coverType.coverTypeId === 120" class="tw-w-full tw-flex tw-h-full tw-flex-col tw-justify-center  tw-border-0 md:tw-border-r tw-my-6">
              <h3 v-for="(benefit, i) in freeBenefits" :key="i" class="c-blue-text tw-text-center c-title-font tw-text-xl md:tw-text-base tw-px-2 md:tw-px-8"> {{ benefit.description }} limit: <span class="tw-font-bold"> Ksh. {{ benefit.benefitValue | formatNum }}</span></h3>
            </div>
          </div>
        </template>
      </div>
    </div>
    <top-stepper :current="current" :cover-type="coverType"></top-stepper>
  </v-card>
</template>
<script>

import helpers from '@/utils/helpers';
import TopStepper from '@/components/buy/TopStepper';

export default {
  name: 'TopCard',
  components: { TopStepper },
  props: {
    current: {
      type: String,
      default: '',
    },
    coverType: Object,
    installments: Array,
    freeBenefits: Array,
    premiumAmount: {
      type: Number,
      required: true,
    },
    progressHidden: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    pageTitle() {
      const coverTypeId = this.scanObject(this.coverType, 'coverTypeId', '');

      if (coverTypeId === 120) {
        return 'Comprehensive Insurance Cover';
      }
      if (coverTypeId === 121) {
        return 'Third Party Insurance Cover';
      }
      return 'Bima Bamba Insurance Cover';
    },
  },
  filters: {
    formatNum(num) {
      return helpers.numberToString(num);
    },
  },
};
</script>
<style lang="scss">
$stepper-header-elevation: 0;
.v-stepper {
  box-shadow: none!important;
}
</style>
